import styled from 'styled-components';

export const Button = styled.div`
  margin-right: 20px;
`;

export const ModalFieldLabel = styled.div`
  font-size: 1rem;
  margin-bottom: 4px;
  margin-top: 10px;
`;

export const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const Th = styled.th`
  min-width: 70px;
  padding: 8px 6px;
  text-align: center;
  vertical-align: middle;
  background: #4b286d;
  color: #fff;
  word-break: break-word;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Td = styled.td`
  border: 1px solid #e3e3e3;
  padding: 6px;
  vertical-align: middle;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const customStylesSelect = {
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "5em", // ~2 lines
      overflowY: "auto",
      flexWrap: "wrap",
    }),
    multiValue: (provided) => ({
      ...provided,
      margin: "2px",
    }),
  };

  export const Search = styled.div`
  display: flex;
  justify-content: flex-end;   /* align its own children to the right */
  margin-left: auto;     
  flex-direction: row;
  padding: 16px 6rem 16px 0;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;

export const ErrorMessage = styled.div`
  color: red;
  margin-top: 1rem;
`;